import { type ReactNode } from 'react'
import { Tile, TileCaption, TileOverlay, TileImage } from '@mc/design-system'
import Image from 'components/LegacyImage'

type PauseVideoScreenProps = {
  captionText: string
  imageSrc?: string
  actionText: string
  pricingText?: ReactNode
  buttonGroup?: ReactNode
}

const PauseVideoScreen = ({
  captionText,
  imageSrc,
  actionText,
  pricingText,
  buttonGroup,
}: PauseVideoScreenProps) => (
  <Tile className='mc-h-100'>
    <TileOverlay type='solid' />
    <TileCaption position='left top'>
      <p className='mc-text-small mc-p-5'>{captionText}</p>
    </TileCaption>
    {imageSrc && (
      <TileImage image={<Image alt='' src={imageSrc} layout='fill' />} />
    )}
    <TileCaption position='center'>
      <div>
        <div className='row'>
          <div className='col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3'>
            <h5 className='mc-text-h5'>{actionText}</h5>
            <p className='d-none d-md-block mc-mt-3'>{pricingText}</p>
            {buttonGroup}
          </div>
        </div>
      </div>
    </TileCaption>
  </Tile>
)

export default PauseVideoScreen
